import { styled } from '@mui/material/styles';
import { Image } from '../../Image';

export const CheckboxIconStyled = styled('span')<{ $checked?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  color: ${({ theme }) => theme.palette.button.contrastOptionText};
  background-color: ${({ theme, $checked }) =>
    $checked ? theme.palette.button.optionHover : 'transparent'};
`;

export const ImageStyled = styled(Image)`
  object-fit: cover;
`;
